import { mapMediaVariants } from '@/common/media';

import type {
  DocumentView,
  DocumentViewDto,
  SingleDocument,
  SingleDocumentDto,
} from './documents.dto';

export const mapSingleDocument = ({
  children_count,
  content_type,
  created_at,
  is_default,
  media_status,
  read_only,
  service_managed,
  storage_link,
  storage_name,
  updated_at,
  created_by,
  parent_id,
  variants,
  ...values
}: SingleDocumentDto): SingleDocument => ({
  ...values,
  childrenCount: children_count,
  contentType: content_type,
  createdAt: created_at,
  // Absent rather than false on the wire; the model states the flag either way so
  // no caller has to remember that a missing key means "no".
  isDefault: is_default ?? false,
  mediaStatus: media_status ?? null,
  readOnly: read_only ?? false,
  serviceManaged: service_managed ?? false,
  storageLink: storage_link,
  storageName: storage_name,
  updatedAt: updated_at,
  createdBy: created_by,
  parentId: parent_id,
  variants: mapMediaVariants(storage_link, variants),
});

export const mapDocumentView = ({
  document_id,
  user_id,
  ...values
}: DocumentViewDto): DocumentView => ({
  ...values,
  documentId: document_id,
  userId: user_id,
});
